import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=de03e32a&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de03e32a')) {
      api.createRecord('de03e32a', component.options)
    } else {
      api.reload('de03e32a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=de03e32a&", function () {
      api.rerender('de03e32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/customer/detail.vue"
export default component.exports